import React, { useState, useEffect } from "react";
import "./style.css";
import NavbarComponent from "../NavbarComponent";
import Footer from "../FooterComponent";
function Missiopn() {
  const [isVison, setisVison] = useState(false);

  useEffect(() => {
    if (window.location.pathname === "/vision") {
      setisVison(true);
    } else {
      setisVison(false);
    }
  }, [window.location.pathname]);

  return (
    <>
      {isVison && <NavbarComponent />}
      <div className="maindivofmission">
        <div className="firstchildmission">
          <h1 className="headingsmission">MISIÓN</h1>
          <h3 className="textofvission-bot">Proporcionar al sector industrial nacional e internacional, soluciones integrales sustentables para el desarrollo de proyectos de infraestructura, vías terrestres y obras complementarias, incluyendo servicios especializados y certificados de arrendamiento de maquinaria, equipo pesado y de autotransporte de carga; nos enfocamos en establecer estrategias para el logro de los estándares de operación, calidad y rentabilidad esperados por nuestros clientes, accionistas, colaboradores y socios de negocios.</h3>
          <h1 className="headingsmission">VISIÓN</h1>
          <h3 className="textofvission-bot">Consolidarnos en el Sureste de México y ampliar nuestra presencia en el país como una empresa que ofrece soluciones integrales a nuestros clientes, con altos estándares de calidad, innovando la prestación de los servicios conforme a los nuevos requerimientos del mercado, con una estructura organizacional eficiente, procesos ágiles, óptimos y de calidad, generando valor agregado y ahorro a nuestros clientes.</h3>

          <h1 className="headingsmission">VALORES</h1>
          <h3 className="textofvission">Nos distinguimos de la competencia a través de los siguientes principios operativos que hemos establecido:</h3>
          <h3 className="textofvission marginbottomclass">• Innovación: Buscamos siempre la forma de ofrecer diversas soluciones creativas a nuestros clientes.</h3>

          <h3 className="textofvission marginbottomclass">• Experiencia: Ofrecemos nuestros servicios a empresas con reconocimiento internacional quienes nos confían sus proyectos.</h3>
          <h3 className="textofvission marginbottomclass">• Calidad: Nuestra oferta de equipos y personal certificado asegura los más altos estándares de calidad en la industria.</h3>
          <h3 className="textofvission marginbottomclass">• Seguridad: Comprometidos con la seguridad y salud de nuestro personal.</h3>
          <h3 className="textofvission marginbottomclass">• Compromiso:Comprometidos con la comunidad para mejorar el entorno social. Cuidamos el medio ambiente en la ejecución de nuestros procesos.</h3>
          <h3 className="textofvission marginbottomclass">• Solvencia: Nuestra capacidad de respuesta es rápida y oportuna a los requerimientos de nuestros clientes.</h3>
        </div>
      </div>
      {isVison && <Footer />}
    </>
  );
}

export default Missiopn;
